import { formatDataType } from '@pn/core/domain/data';
import type { NotificationId } from '@pn/core/services/notifications/ports';
import { notificationService } from '@pn/services/notifications';
import { isNil } from 'lodash-es';

export function showPersistentStreamingNotification(params: {
  action: string;
  dataType: string;
}): NotificationId | undefined {
  const { action, dataType } = params;

  return notificationService.render({
    content: `${action} ${formatDataType(dataType)}...`,
    options: {
      showSpinner: true,
    },
  });
}

export function removePersistentStreamingNotification(
  notificationId: NotificationId | undefined
): void {
  if (!isNil(notificationId)) {
    notificationService.remove(notificationId);
  }
}
